import { render, staticRenderFns } from "./HowToRecharge.vue?vue&type=template&id=16598c8b&scoped=true&"
import script from "./HowToRecharge.vue?vue&type=script&lang=js&"
export * from "./HowToRecharge.vue?vue&type=script&lang=js&"
import style0 from "./HowToRecharge.vue?vue&type=style&index=0&id=16598c8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16598c8b",
  null
  
)

export default component.exports